(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}
parcelRequire.register("l6fPl", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f5c66f7974fb7167$export$6503ec6e8aabbaf; }, function (v) { return $f5c66f7974fb7167$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f5c66f7974fb7167$export$f7ad0328861e2f03; }, function (v) { return $f5c66f7974fb7167$export$f7ad0328861e2f03 = v; });
var $f5c66f7974fb7167$export$6503ec6e8aabbaf;
var $f5c66f7974fb7167$export$f7ad0328861e2f03;
"use strict";
var $f5c66f7974fb7167$var$mapping = {};
function $f5c66f7974fb7167$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f5c66f7974fb7167$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f5c66f7974fb7167$var$resolve(id) {
    var resolved = $f5c66f7974fb7167$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f5c66f7974fb7167$export$6503ec6e8aabbaf = $f5c66f7974fb7167$var$register;
$f5c66f7974fb7167$export$f7ad0328861e2f03 = $f5c66f7974fb7167$var$resolve;

});

var $033c7710b5db95f3$exports = {};

(parcelRequire("l6fPl")).register(JSON.parse('{"6L7xj":"index.b6e403c3.js","da3uE":"logo.67b043dc.png","64ciE":"Grocery.2edb5aed.js","g4FJ5":"index.2940f66e.css"}'));

})();
//# sourceMappingURL=index.d5dc59b4.js.map
